import { BASE_URL } from './Config.js';

export class GestionStockService {

  fetchAllStock = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors du chargement du stock');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching stock:', error);
      throw error;
    }
  };

  fetchAllBCF = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/bcf/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors du chargement des BCF');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching BCF:', error);
      throw error;
    }
  };


  // 1. Récupérer les données de l'onglet Réception
  fetchReceptions = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      //  Adaptez cette URL si votre endpoint backend s'appelle différemment 
      // (ex: /api/v1/stock/pending-receptions ou /api/v1/bcf/pending)
      const response = await fetch(`${BASE_URL}/stock/receptions`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors du chargement des réceptions');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching receptions:', error);
      throw error;
    }
  };

  // Sauvegarder les réceptions en appelant l'endpoint /receive/{bcfLineId} pour chaque ligne
    saveReception = async (lignes) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      let successCount = 0;

      for (const ligne of lignes) {
        const qty = Number(ligne.quantity);
        
        if (qty > 0) {
          const response = await fetch(`${BASE_URL}/stock/receive/${ligne.id}`, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json', 
              'Authorization': `Bearer ${token}` 
            },
            //la clé JSON correspond maintenant exactement au backend
            body: JSON.stringify({ quantityReceived: qty }) 
          });

          if (!response.ok) {
            const errorData = await response.text();
            throw new Error(`Erreur sur la ligne ID ${ligne.id} : ${errorData}`);
          }
          successCount++;
        }
      }

      return successCount > 0 
        ? `${successCount} réception(s) effectuée(s) avec succès !`
        : "Aucune quantité à réceptionner.";

    } catch (error) {
      console.error('Error saving reception:', error);
      throw error;
    }
  };


  // STEP 5a: RECEPTION (BCF Line → Global Stock)
  postReception = async (bcfLineId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/receive/${bcfLineId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors de la réception');
      }
      return await response.text();
    } catch (error) {
      console.error('Error posting reception:', error);
      throw error;
    }
  };

  // STEP 5b: ATTRIBUTION (Global Stock → Mandat Line)
  // Payload attendu par StockToMandatRequestDTO: { productId, mandatId, quantityToAttribute }
  postAttribution = async (requestPayload) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/attribute-to-mandat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(requestPayload)
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de l'attribution");
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting attribution:', error);
      throw error;
    }
  };

  // STEP 5c: ROLLBACK / RELEASE (Mandat Line → Global Stock)
  deleteReleaseFromMandat = async (mandatLineId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/release-from-mandat/${mandatLineId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Erreur lors de la libération du stock');
      }
      return await response.text();
    } catch (error) {
      console.error('Error deleting release from mandat:', error);
      throw error;
    }
  };
  
    //Récupérer les lignes BCF entièrement reçues pour l'attribution
  fetchFullyReceivedForReception = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/fully-received-for-reception-stock`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors du chargement des lignes entièrement reçues');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching fully received lines:', error);
      throw error;
    }
  };

    // Récupérer le stock réellement disponible (Reçu et Non Attribué)
  fetchAvailableStock = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/stock/available`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors du chargement du stock disponible');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching available stock:', error);
      throw error;
    }
  };

    //  Récupérer les mandats ayant au moins une ligne non clôturée
    fetchOpenMandats = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/mandat/open`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}` 
      }
    });

    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Erreur chargement mandats');
    }
    
    return await response.json();
  };

 // fetch stock by ref fabricant
  fetchStockByRefFabricant = async (refFabricant) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) return 0;

      const response = await fetch(`${BASE_URL}/stock/availablebyid/${encodeURIComponent(refFabricant)}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (!response.ok) return 0;
      return await response.json();
    } catch (error) {
      return 0;
    }
  };
}